import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetProfilePhotoRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetProfilePhotoResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setProfilePhoto = (request: SetProfilePhotoRequest, options?: CashRequestOptions) =>
  post<SetProfilePhotoRequest, SetProfilePhotoResponse>('/2.0/cash/set-profile-photo', request, {
    ...options,
    rejectOnError: true,
  })
